export const bannerCardsData = [
  {
    title: "",
    description: "",
    icon: "",
    className: "-rotate-3 ",
    classNameForInnerParent: "border-t-[3px] border-l-[3px]",
    classNameForDot: " right-2 top-2",
  },
  {
    title: "",
    description: "",
    icon: "",
    className: "rotate-3 flex  justify-end",
    classNameForInnerParent: "border-t-[3px] border-r-[3px]",
    classNameForDot: " left-1 top-1",
  },
  {
    title: "",
    description: "",
    icon: "",
    className: "rotate-3 flex  items-end justify-start",
    classNameForInnerParent: "border-b-[3px] border-l-[3px]",
    classNameForDot: " left-1 top-1",
  },
  {
    title: "",
    description: "",
    icon: "",
    className: "-rotate-3 flex items-end justify-end",
    classNameForInnerParent: "border-b-[3px] border-r-[3px]",
    classNameForDot: " right-1 top-1",
  },
];
